module.exports = __webpack_public_path__ + "media/application/images/process_steps/mobile_bookstack_00-7518c7a45d01cc27f3a2b4f99cae1fbc.png";